import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';

import { useGetAssociation } from 'legacy/groups/hooks';
import Redirect from 'legacy/components/util/Redirect/Redirect';

interface Props {
  children: ReactNode;
}

/**
 * This component is a wrapper component to gate-keep association management so only authorized users can operate.
 * Used in all the flows that required restricted access to an association.
 */
const AssociationAdminWrapper = ({ children }: Props) => {
  const { query } = useRouter();

  const {
    data: association,
    isLoading,
    isError
  } = useGetAssociation({
    associationId: query.associationId as string
  });

  /**
   * If fetching the association failed or the user is not an admin:
   *    Redirect to a 404.
   */
  if (isError || (association && !association.isUserAdmin)) {
    return <Redirect to="/404" />;
  }

  return isLoading ? null : <>{children}</>;
};

export default AssociationAdminWrapper;
